import lodingAnimation from "../../assets/lottie/loding.json";
import Lottie from "lottie-react";
import { styled, Dialog } from "@mui/material";
type Loding_type = {
  isLoading: boolean;
};

const Container = styled(Dialog)`
  .MuiPaper-root {
    background-color: transparent;
    box-shadow: none;
  }
`;

const Loading = (props: Loding_type) => {
  const { isLoading } = props;

  return (
    <Container open={isLoading}>
      <Lottie animationData={lodingAnimation} />
    </Container>
  );
};

export default Loading;
